var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feedback/success-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99916 19.0706C14.733 19.0706 18.5706 15.233 18.5706 10.4992C18.5706 5.76529 14.733 1.92773 9.99916 1.92773C5.26529 1.92773 1.42773 5.76529 1.42773 10.4992C1.42773 15.233 5.26529 19.0706 9.99916 19.0706ZM9.99916 17.9277C5.89648 17.9277 2.57059 14.6019 2.57059 10.4992C2.57059 6.39648 5.89648 3.07059 9.99916 3.07059C14.1019 3.07059 17.4277 6.39648 17.4277 10.4992C17.4277 14.6019 14.1019 17.9277 9.99916 17.9277ZM6.16653 10.0951C6.38969 9.87195 6.7515 9.87195 6.97465 10.0951L8.85631 11.9768L13.0237 7.80939C13.2468 7.58623 13.6086 7.58623 13.8318 7.80939C14.055 8.03254 14.055 8.39435 13.8318 8.61751L9.30077 13.1485C9.0553 13.394 8.65731 13.394 8.41184 13.1485L6.16653 10.9032C5.94337 10.6801 5.94337 10.3183 6.16653 10.0951Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircle);
export default __webpack_public_path__ + "static/media/success-circle.d3b350e2.svg";
export { ForwardRef as ReactComponent };